"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var deprecate_1 = require("../../deprecate");
var HOVER_DELAY = 100; // ms
var UNHOVER_DELAY = 500; // ms
// Used to show a div on hover intent of some trigger component. This is similar to
// a tooltip. Because it adds a delay between mouseLeave and closing the panel, it
// allows for the mouse to travel to the panel and stay open, so that the user can
// click a link for example.
//
// triggerProps - Props that will be passed down to the <a> button.
// showOnce (optional, default false) - If true, it will open the panel on initial
// render, and once unhovered, will never show again. This is useful for eg success
// messages on clicking a button.
//
// <TooltipPanel>
//    <p>panel content</p>
// </Panel>
//
// Please don't use this for any future tooltip needs; use CSS-driven tooltips from commons
// It's exported for 1 use in core right now and will eventually be dprecated
var TooltipPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TooltipPanel, _super);
    function TooltipPanel(props) {
        var _this = _super.call(this, props) || this;
        deprecate_1.deprecate('TooltipPannel is deprecated, please use the CSS tooltips in commons');
        _this.state = {
            isOpen: props.isOpenInitially || props.showOnce || false,
        };
        _this.handleContainerClick = _this.handleContainerClick.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.showPanel = _this.showPanel.bind(_this);
        _this.hidePanel = _this.hidePanel.bind(_this);
        _this.togglePanel = _this.togglePanel.bind(_this);
        _this.mouseEnterCallback = null;
        _this.mouseLeaveCallback = null;
        return _this;
    }
    Object.defineProperty(TooltipPanel, "propTypes", {
        get: function () {
            return {
                enabled: PropTypes.bool,
                triggerProps: PropTypes.object,
                showOnce: PropTypes.bool,
                children: PropTypes.node,
                isOpenInitially: PropTypes.bool,
                triggerOnHover: PropTypes.bool,
                align: PropTypes.oneOf(['left', 'right', 'center']),
                onOpen: PropTypes.func,
                onClose: PropTypes.func,
                className: PropTypes.string,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipPanel, "defaultProps", {
        get: function () {
            return {
                enabled: true,
                triggerOnHover: false,
                triggerProps: {},
                align: 'center',
                onOpen: function () { },
                onClose: function () { },
            };
        },
        enumerable: true,
        configurable: true
    });
    TooltipPanel.prototype.componentDidMount = function () {
        document.addEventListener('click', this.hidePanel);
    };
    TooltipPanel.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.hidePanel);
    };
    TooltipPanel.prototype.handleContainerClick = function (e) {
        if (e.nativeEvent.stopImmediatePropagation) {
            e.nativeEvent.stopImmediatePropagation();
        }
    };
    TooltipPanel.prototype.handleMouseEnter = function () {
        if (!this.props.triggerOnHover) {
            return;
        }
        this.clearTimeouts();
        if (this.props.showOnce) {
            return;
        }
        this.mouseEnterCallback = window.setTimeout(this.showPanel, HOVER_DELAY);
    };
    TooltipPanel.prototype.handleMouseLeave = function () {
        if (!this.props.triggerOnHover) {
            return;
        }
        this.clearTimeouts();
        this.mouseLeaveCallback = window.setTimeout(this.hidePanel, UNHOVER_DELAY);
    };
    TooltipPanel.prototype.clearTimeouts = function () {
        window.clearTimeout(this.mouseEnterCallback);
        window.clearTimeout(this.mouseLeaveCallback);
    };
    TooltipPanel.prototype.showPanel = function () {
        this.setState({ isOpen: true }, this.props.onOpen);
    };
    TooltipPanel.prototype.hidePanel = function () {
        this.setState({ isOpen: false }, this.props.onClose);
    };
    TooltipPanel.prototype.togglePanel = function (e) {
        e.preventDefault();
        if (this.state.isOpen) {
            this.hidePanel();
        }
        else {
            this.showPanel();
        }
    };
    TooltipPanel.prototype.renderPanel = function () {
        if (this.state.isOpen) {
            return (React.createElement("div", { className: "tooltip-panel__content" }, this.props.children));
        }
        return null;
    };
    TooltipPanel.prototype.renderTrigger = function () {
        var props = tslib_1.__assign({ onClick: this.togglePanel, href: '#' }, this.props.triggerProps);
        return (React.createElement("a", tslib_1.__assign({}, props)));
    };
    TooltipPanel.prototype.render = function () {
        if (!this.props.enabled) {
            return this.renderTrigger();
        }
        return (React.createElement("div", { className: "tooltip-panel tooltip-panel--align-" + this.props.align + " " + this.props.className, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onClick: this.handleContainerClick },
            this.renderTrigger(),
            this.renderPanel()));
    };
    return TooltipPanel;
}(React.Component));
exports.default = TooltipPanel;
//# sourceMappingURL=tooltip_panel.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/tooltip_panel.js
// module id = D/iT
// module chunks = 20 21